import { useMutation } from '@tanstack/react-query';
import { ProductForm } from '../../components/ProductForm';
import { useLijsten, useSuggesties } from '../../lib/useLijsten';
import { voorraadApi } from './voorraad.api';
import { VoorraadLijst } from './VoorraadLijst';

/** De voorraad-tab: wat er in de kast staat, en wat er bijna op is. */
export function VoorraadPage() {
  const { voorraad, ververs, meldFout, toast } = useLijsten();
  const suggesties = useSuggesties();

  const voegToe = useMutation({
    mutationFn: voorraadApi.create,
    onSuccess: () => {
      ververs();
      toast('Toegevoegd aan de voorraad');
    },
    onError: meldFout,
  });

  const isOp = useMutation({
    mutationFn: voorraadApi.isOp,
    onSuccess: ({ item }) => {
      ververs();
      // Extra van belang op deze tab: de boodschappenlijst is hier niet te zien,
      // dus zonder melding lijkt het alsof de regel gewoon verdwijnt.
      toast(`${item.naam} staat nu op de boodschappenlijst`);
    },
    onError: meldFout,
  });

  const verwijder = useMutation({
    mutationFn: voorraadApi.remove,
    onSuccess: ververs,
    onError: meldFout,
  });

  const pasAan = useMutation({
    mutationFn: ({
      id,
      velden,
    }: {
      id: string;
      velden: { aantal?: number; minimum?: number | null };
    }) => voorraadApi.update(id, velden),
    onSuccess: ververs,
    onError: meldFout,
  });

  return (
    <>
      <section>
        <h2 className="vs-section-title">In voorraad zetten</h2>
        <div className="vs-card">
          <ProductForm
            idPrefix="voorraad"
            knopLabel="In voorraad"
            bezig={voegToe.isPending}
            suggesties={suggesties.data?.suggesties}
            onSubmit={async (waarden) => {
              await voegToe.mutateAsync(waarden);
              return true;
            }}
          />
        </div>
      </section>

      <section>
        <h2 className="vs-section-title">Voorraad</h2>
        {voorraad.isPending ? (
          <p className="vs-empty">Laden…</p>
        ) : voorraad.isError ? (
          <p className="vs-empty">De voorraad kon niet worden geladen.</p>
        ) : (
          <VoorraadLijst
            voorraad={voorraad.data.voorraad}
            onIsOp={(id) => isOp.mutate(id)}
            onVerwijder={(id) => verwijder.mutate(id)}
            onAanpassen={(id, velden) => pasAan.mutate({ id, velden })}
          />
        )}
      </section>
    </>
  );
}
